export default {
  enable() {
    // NOSONAR
    // eslint-disable-next-line no-unused-expressions,wrap-iife
    !(function (w, d, t) {
      w.TiktokAnalyticsObject = t;
      let ttq = (w[t] = w[t] || []);
      const methods = [
        "page",
        "track",
        "identify",
        "instances",
        "debug",
        "on",
        "off",
        "once",
        "ready",
        "alias",
        "group",
        "enableCookie",
        "disableCookie"
      ];
      ttq.methods = methods;
      ttq.setAndDefer = function (t, e) {
        t[e] = function () {
          t.push([e].concat(Array.prototype.slice.call(arguments, 0)));
        };
      };
      for (let method of ttq.methods) ttq.setAndDefer(ttq, method);
      ttq.instance = function (t) {
        const e = ttq._i[t] || [];
        for (let method of ttq.methods) ttq.setAndDefer(e, method);
        return e;
      };
      ttq.load = function (e, n) {
        const i = "https://analytics.tiktok.com/i18n/pixel/events.js";
        ttq._i = ttq._i || {};
        ttq._i[e] = [];
        ttq._i[e]._u = i;
        ttq._t = ttq._t || {};
        ttq._t[e] = +new Date();
        ttq._o = ttq._o || {};
        ttq._o[e] = n || {};
        n = document.createElement("script");
        n.type = "text/javascript";
        n.async = !0;
        n.src = i + "?sdkid=" + e + "&lib=" + t;
        e = document.getElementsByTagName("script")[0];
        e.parentNode.insertBefore(n, e);
      };
      ttq.load("CU95Q1BC77U8ER4FJCGG");
      ttq.page();
    })(window, document, "ttq");
  },
  wait() {
    return !!window.ttq;
  },
  init() {},
  paso1() {
    window.ttq.track("AddToWishlist", {
      contents: [
        {
          content_type: "product",
          content_name: "datospersonales"
        }
      ]
    });
  },
  paso2() {
    window.ttq.track("AddPaymentInfo", {
      contents: [
        {
          content_type: "product",
          content_name: "elccionpremios"
        }
      ]
    });
  },
  paso3() {
    window.ttq.track("CompletePayment", {
      contents: [
        {
          content_type: "product",
          content_name: "compartirlink"
        }
      ]
    });
  }
};
